/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setDarkTheme, setLightTheme } from "../redux/dark-light-theme";
//Import Switcher CSS
const ThemeSwitcher = () => {
  const [isSwitchToggle, setIsSwitchToggle] = useState(false);
  const isDark = useSelector((state) => state.themeDart.dark)
  const dispatch = useDispatch()
  const switcherRef = useRef(null);
  const toggleSwitcher = () => {
    setIsSwitchToggle(!isSwitchToggle)
  }
  const handleClickOutside = (event) => {
    if (switcherRef.current && !switcherRef.current.contains(event.target)) {
      setIsSwitchToggle(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <React.Fragment>
      <div ref={switcherRef}
        id="style-switcher"
        style={{ left: isSwitchToggle ? "0px" : "-189px" }}
        className="bg-light border p-3 pt-2 pb-2">
        <h6 className="title text-center pt-3 mb-0">Theme Option</h6>
        <div className="text-center">
          <div
            className="btn btn-sm w-100 btn-soft-primary mt-2"
            onClick={() => {

              dispatch(setDarkTheme(false))
              setIsSwitchToggle(false)
            }}
          >
            Light
          </div>
          <div
            className="btn btn-sm w-100 btn-dark mt-2"
            onClick={() => {

              dispatch(setDarkTheme(true))
              setIsSwitchToggle(false)
            }}>
            Dark
          </div>
        </div>
        <div className="bottom" id="btnSwitcher">
          <Link
            to="#"
            onClick={toggleSwitcher}
            className="settings switcher-btn shadow-md text-soft-primary bg-white"
          >
            <i className="mdi mdi-cog ms-1 mdi-24px position-absolute mdi-spin text-dark"></i>
          </Link>
        </div>
      </div>

    </React.Fragment>
  );
}

export default ThemeSwitcher;
